import React, {
  Fragment,
  useMemo,
  useContext,
  useState,
  useEffect,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { MuiThemeProvider } from "@material-ui/core/styles"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { head } from "lodash"

import {
  Box,
  CircularProgress,
  Button,
  Paper,
  Grid,
  useTheme,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core"
import { Link } from "react-router-dom";
import billingTheme from "../../../../themes/billing"
import { Redirect, withRouter } from "react-router"
import { Route, Switch } from "react-router-dom"
import BillApprovalPage from "./pages/billApproval"
import DealMemoPage from "./pages/dealMemo"
import EstimatePage from "./pages/estimate"
import InvoicePage from "./pages/invoice"
import calculateTotals from "../../../../utils/calculateTotals"
import InvoiceRight from "../../../../components/Billing/Admin/InvoiceRight/index"
import AddRoleDialog from "../../../../components/AddRoleDialog/index"
import GreenButton from "../../../../components/Billing/Common/GreenButton/index"
import LoadingButton from "../../../../components/LoadingButton"
import BillingContext, { BillingContainer } from "./BillingContext"
import NextStep from "../../../../components/NextStep/index"
import { setClientCompanyShoots } from "../../../../actions/shoots"

import { openSnackBar } from "../../../../actions/snack-bar"
import {
  updateAllCrewStatus,
  updateDealMemoBillingStep,
} from "../../../../actions/billing"
import {
  getCompanyShoots
} from "../../../../actions/shoots"
import { toggleClickConfirmationDialog } from "../../../../actions/billingDialogs"
import moment from "moment"
import Breadcrumbs from "../../../../components/Billing/Admin/Breadcrumbs/index"
import CopyLinkButton from "../../../../components/Billing/Common/CopyLinkButton/index"
import DownloadPdfButton from "../../../../components/Billing/Common/DownloadPdfButton/index"
import CrewStatusTable from "../../../../components/Billing/Admin/CrewStatusTable/index"
import EstimateRightContent from "../../../../components/Billing/Admin/EstimateRightContent/index"
import BillingPageLayout from "../../../../components/Billing/Common/BillingPageLayout/index"
import usePaidAmountInvoice from "../../../../hooks/usePaidAmountInvoice"
import usePaidAmountEstimate from "../../../../hooks/usePaidAmountEstimate"
import useBillingDisabled from "../../../../hooks/useBillingDisabled"
import useActiveCompanyAdesk from "../../../../hooks/useActiveCompanyAdesk"
import convertAdeskToOrganization from "../../../../utils/convertAdeskToOrganization"
import { adeskPhones } from "../../../../utils/adeskPhones"
import { Typography } from "../../../../../node_modules/@material-ui/core/index"
import { clearConfigCache } from "prettier"

const ShootBillingContent = props => {
  const { match } = props
  const [resendLoading, setResendLoading] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const dispatch = useDispatch()
  const theme = useTheme()

  let shootId = match.params.shoot_id

  const { currentShootData, loading } = useContext(BillingContext)

  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)
  const generalData = useSelector(state => state.billing.generalData)
  const clientCompanyShoots = useSelector(state => state.shoots.clientShoots)

  const billingContext = useContext(BillingContext)

  const allSaved = billingContext.unsavedState.length === 0

  const isDisabled = useBillingDisabled()

  useEffect(
    () => {
      if (generalData.client_company_id)
        dispatch(getCompanyShoots(generalData.client_company_id))
    },
    [generalData.client_company_id]
  )


  const handleApplicantExpansion = () => {
    setExpanded(!expanded)
  }

  const clientSideUserRole = useMemo(
    () => {
      let clientRole = usersRolesArray.map((item) => {
        return ({
          ...item,
          expenses: item.expenses.filter((ele) => ele.class !== "non-billable")

        })
      })
      return clientRole
    },
    [usersRolesArray]
  )

  // disabled indicators for Continue to Estimate & Continue to Invoice buttons
  const disableContinueToEstimate = useMemo(
    () => {
      if (usersRolesArray.length) {
        if (
          usersRolesArray.filter(
            x =>
              !x.user_status ||
              x.user_status === "sent" ||
              x.user_status === "unsent"
          ).length > 0
        ) {
          return true
        }
        return false
      }
      return true
    },
    [usersRolesArray]
  )

  const disableContinueToInvoice = useMemo(
    () => {
      if (usersRolesArray.length) {
        if (
          usersRolesArray.filter(x => x.user_status !== "approved").length > 0
        )
          return true
      }
      return false
    },
    [usersRolesArray]
  )
  // end disabled indicators

  const routes = useMemo(
    () => {
      if (currentShootData && currentShootData.name) {
        return {
          dealMemo: {
            leftHeader: `Deal Memo for ${currentShootData.name}`,
            rightHeader: "Status",
            rightSubtitle: "",
          },
          estimate: {
            leftHeader: `Estimate for ${currentShootData.name}`,
            rightHeader: "Summary",
            rightSubtitle: "",
          },
          shoot: {
            leftHeader: `ShohandleApplicantExpansionot for ${currentShootData.name}`,
            rightHeader: "Summary",
            rightSubtitle: "",
          },
          invoice: {
            leftHeader: `Invoice for ${currentShootData.name}`,
            rightHeader: "Summary",
            rightSubtitle: "",
          },
          billApproval: {
            leftHeader: `Billing for ${currentShootData.name}`,
            rightHeader: "Final Crew Billing",
            // rightSubtitle: "This estimate was accepted by ::First Last::",
          },
        }
      } else {
        return {}
      }
    },
    [currentShootData]
  )
  const startDate = moment(generalData.start_date).format("MMM Do YYYY")
  const daysAway = moment(generalData.start_date)
    .startOf("day")
    .fromNow()

  const nextStepMessage = useMemo(() => {
    let message = " "
    if (generalData.billing_step_name === "Deal Memo") {
      message =
        "Once all crew members have accepted their deal memos, the shoot will be booked."
    } else if (generalData.billing_step_name === "Estimate") {
      message =
        "Once the shoot has wrapped, each crew member will submit any additional shoot expenses for you to review."
    } else if (generalData.billing_step_name === "Bill Approval") {
      message =
        "Once the client has accepted your additional expenses and paid in full, your shoot payment will be transferred."
    } else if (generalData.billing_step_name === "Invoice") {
      message =
        "Please accept and pay this invoice in a timely manner so that we may submit payment to the shoot crew."
    } else {
      message = "Not a valid shoot"
    }
    return message
  })

  const [headerText, setHeaderText] = React.useState({
    leftHeader: "",
    rightHeader: "",
    rightSub: "",
  })

  const camelize = s => s.replace(/-./g, x => x[1].toUpperCase())
  const page = camelize(
    window.location.pathname.split("/")[
    window.location.pathname.split("/").length - 1
    ]
  )

  //ue to watch path, display
  useEffect(
    () => {
      if (
        window.location.pathname &&
        currentShootData &&
        currentShootData.name
      ) {
        setHeaderText({ ...(routes && routes[page]) })
      }
    },
    [window.location.pathname, currentShootData]
  )

  // handles both resend & send all deal memos, keying off type passed in dialog fn
  const handleSendResendAll = type => {
    if (type === "all") {
      setSendLoading(true)
    } else {
      setResendLoading(true)
    }
    dispatch(updateAllCrewStatus(shootId, { sendType: type }))
      .then(res => {
        if (type === "all") {
          setSendLoading(false)
          dispatch(
            openSnackBar({
              message: `Sent all crew deal memos successfully`,
            })
          )
        } else {
          setResendLoading(false)
          let snackbarMessage =
            res.message === "No users need email"
              ? `${res.message}`
              : `Resent all crew deal memos successfully`
          dispatch(
            openSnackBar({
              message: snackbarMessage,
            })
          )
        }
      })
      .catch(err => {
        if (type === "all") {
          setSendLoading(false)
        } else {
          setResendLoading(false)
        }
        console.log(err)
        dispatch(openSnackBar({ message: `Error sending all deal memos` }))
      })
  }

  const confirmSendDialog = type => {
    //using button text as key to type - resend or send
    !allSaved && billingContext.setUnsavedErrorBorder(true)
    let modifiedType = type === "all" ? "send" : type
    let data = {
      action: allSaved
        ? `${modifiedType} ${type === "all"
          ? "deal memos to every crew member"
          : "deal memos to every not available crew member"
        } `
        : `${modifiedType} ${type === "all"
          ? "deal memos to every crew member without saving"
          : "deal memos to every not available crew member without saving"
        }`,
      confirmationFunc: handleSendResendAll,
      funcArgs: [type],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // end send/resend all deal memos logic

  const handleAdvanceStep = currentStep => {
    const stepData = {
      billing_step: currentStep,
      direction: "next",
    }
    dispatch(updateDealMemoBillingStep(stepData, shootId))
      .then(res => {
        const newPage = res.data.step_name.replace(/\s+/g, "-").toLowerCase()
        props.history.push(`/shoots/${shootId}/billing/${newPage}`)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const paidAmtInvoice = usePaidAmountInvoice()
  const paidAmtEstimate = usePaidAmountEstimate()

  // amounts to be passed into PDF generator
  // using locking in 50 percent amount for estimate, paid amount for invoice
  const amounts = useMemo(
    () => {
      if (generalData && usersRolesArray) {
        return calculateTotals(
          usersRolesArray,
          page === "estimate" ? paidAmtEstimate : paidAmtInvoice,
          generalData.discount
        )
      }
    },
    [generalData, usersRolesArray, page, paidAmtInvoice, paidAmtEstimate]
  )

  //disable Send All of Resend All if an unassigend role - returns bool value
  const hasUnassigned = useMemo(
    () => {
      if (usersRolesArray) {
        return usersRolesArray.filter(x => !x.user_id).length > 0
      }
    },
    [usersRolesArray]
  )

  const checkDiscount = useMemo(
    () => {
      if (usersRolesArray.length > 0) {
        let discountArr = []
        // usersrolesarray combines both reg & additional expenses for all roles & users
        usersRolesArray.map(x =>
          x.expenses.filter(y => {
            if (y.discount && y.discount > 0) {
              discountArr = [...discountArr, y]
            }
            return discountArr
          })
        )
        if (page === "invoice") {
          usersRolesArray.map(x =>
            x.additional_expenses.filter(y => {
              if (y.discount && y.discount > 0) {
                discountArr = [...discountArr, y]
              }
              return discountArr
            })
          )
        }
        return discountArr.length > 0
      } else {
        return false
      }
    },
    [usersRolesArray, page]
  )

  const isAdesk = useActiveCompanyAdesk() || generalData.company_id === 2

  return !currentShootData || !currentShootData.name || loading ? (
    <CircularProgress />
  ) : (
    <BillingPageLayout
      leftHeader={headerText && headerText.leftHeader}
      leftContent={
        <Fragment>
          <Grid style={{ overflowX: "scroll" }}>
            <Breadcrumbs />
          </Grid>
          <Switch>
            <Route exact path={`${match.path}`}>
              <Redirect to={`${match.url}/deal-memo`} />
            </Route>
            <Route
              path={`${match.path}/bill-approval`}
              component={BillApprovalPage}
            />
            <Route path={`${match.path}/deal-memo`} component={DealMemoPage} />
            <Route path={`${match.path}/estimate`} component={EstimatePage} />
            <Route path={`${match.path}/invoice`} component={InvoicePage} />
          </Switch>
          <AddRoleDialog />
        </Fragment>
      }
      rightHeader={headerText && headerText.rightHeader}
      rightHeaderButtons={
        page === "estimate" || page === "invoice" ? (
          <Fragment>
            {
              page === "invoice" &&
              <Box
                style={{ marginRight: "10px" }}
              >
                <DownloadPdfButton
                  type="invoice"
                  data={{
                    ...generalData,
                    users: clientSideUserRole,
                    passedAmounts: amounts,
                    company_name:
                      isAdesk && (generalData && generalData.crewmama_or_gtt)
                        ? convertAdeskToOrganization(generalData.crewmama_or_gtt)
                        : generalData.company_name,
                    company_phone: isAdesk
                      ? adeskPhones(generalData.crewmama_or_gtt)
                      : generalData.company_phone,
                    hasLineDiscounts: checkDiscount,
                  }}
                  client={true}

                />
              </Box>

            }
            <DownloadPdfButton
              type={page}
              data={{
                ...generalData,
                users: usersRolesArray,
                passedAmounts: amounts,
                company_name:
                  isAdesk && (generalData && generalData.crewmama_or_gtt)
                    ? convertAdeskToOrganization(generalData.crewmama_or_gtt)
                    : generalData.company_name,
                company_phone: isAdesk
                  ? adeskPhones(generalData.crewmama_or_gtt)
                  : generalData.company_phone,
                hasLineDiscounts: checkDiscount,
              }}
            />
            <Box width="10px" />
            <CopyLinkButton
              docType={page}
              uniqueString={generalData.client_unique_string}
              {...props}
            />
          </Fragment>
        ) : null
      }
      rightSubtitle={headerText && headerText.rightSubtitle}
      rightContent={
        <Fragment
        >
          <Switch>
            {/* Bill Approval Route Start */}
            <Route
              path={`${match.path}/bill-approval`}
              render={props => (
                <Fragment>
                  <CrewStatusTable
                    {...props}
                    crewList={usersRolesArray}
                    statusLabel="Approved"
                  />
                  {generalData.billing_step === 2 && (
                    <Button
                      style={{
                        color: theme.palette.error.main,
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                      disabled={disableContinueToInvoice}
                      disableRipple
                      onClick={() =>
                        handleAdvanceStep(generalData.billing_step)
                      }
                    >
                      Continue to Invoice {">"}
                    </Button>
                  )}
                  <Box style={{ marginTop: "60px" }}>
                    {generalData.billing_step_name === "Bill Approval" &&
                      window.location.pathname.includes("/bill-approval") ? (
                      <NextStep
                        message={nextStepMessage}
                        shootDate={startDate}
                        daysAway={daysAway}
                      />
                    ) : null}
                  </Box>
                </Fragment>
              )}
            />
            {/* Bill Approval Route End */}
            {/* Deal Memo Route Start */}
            <Route
              path={`${match.path}/deal-memo`}
              render={props => (
                <Fragment>
                  <CrewStatusTable
                    {...props}
                    crewList={usersRolesArray}
                    statusLabel="Accepted"
                  />
                  {generalData.billing_step === 0 && (
                    <Button
                      style={{
                        color: theme.palette.error.main,
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                      disabled={disableContinueToEstimate}
                      disableRipple
                      onClick={() =>
                        handleAdvanceStep(generalData.billing_step)
                      }
                    >
                      Continue to Estimate {">"}
                    </Button>
                  )}
                  <Box alignSelf="center" width="80%" mt={3}>
                    <GreenButton
                      variant="contained"
                      fullWidth
                      onClick={() => confirmSendDialog("all")}
                      disabled={
                        !usersRolesArray.length ||
                        sendLoading ||
                        hasUnassigned ||
                        isDisabled
                      }
                    >
                      {sendLoading ? (
                        <CircularProgress
                          style={{ color: "inherit" }}
                          size={28}
                        />
                      ) : (
                        "Send All Deal Memos"
                      )}
                    </GreenButton>
                    <LoadingButton
                      variant="contained"
                      fullWidth
                      color="primary"
                      disabled={
                        !usersRolesArray.length ||
                        resendLoading ||
                        hasUnassigned ||
                        isDisabled
                      }
                      onClick={() => confirmSendDialog("resend")}
                      style={{
                        marginTop: "14.5px",
                      }}
                    >
                      {resendLoading ? (
                        <CircularProgress size={28} />
                      ) : (
                        "Resend All Deal Memos"
                      )}
                    </LoadingButton>

                    <Box style={{ marginTop: "50px" }}>
                      {generalData.billing_step_name === "Deal Memo" &&
                        window.location.pathname.includes("/deal-memo") ? (
                        <NextStep
                          message={nextStepMessage}
                          shootDate={startDate}
                          daysAway={daysAway}
                        />
                      ) : null}
                    </Box>
                  </Box>
                </Fragment>
              )}
            />
            {/* Deal Memo Route End */}
            <Route
              path={`${match.path}/estimate`}
              component={EstimateRightContent}
            />
            <Route path={`${match.path}/invoice`} component={InvoiceRight} />
          </Switch>
          {
            clientCompanyShoots && clientCompanyShoots[0] && <Grid item sm={12}>
              <ExpansionPanel
                style={{
                  borderRadius: "10px",
                }}
                expanded={expanded}
              >
                <Paper
                  elevation={3}
                  style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "fit-content",
                    backgroundColor: "pink",
                    borderRadius: "10px"
                  }}
                >
                  <Typography
                    component="p"
                    style={{
                      fontSize: "0.9em",
                      alignSelf: "center",
                      fontWeight: 500,
                    }}
                  >
                    Company's Shoot History
                  </Typography>
                  <ExpansionPanelSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    expandIcon={
                      false ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )
                    }
                    onClick={() =>
                      handleApplicantExpansion()
                    }

                  >
                    {/* <Typography
                      component="p"
                      style={{
                        width: "max-content",
                        fontSize: "0.7em",
                        alignSelf: "center",
                        fontWeight: 600,
                      }}
                    >{clientCompanyShoots[0].length === 1 ? clientCompanyShoots[0].length + " shoot" : (clientCompanyShoots[0].length - (clientCompanyShoots[0].findIndex(item => item.shoot_id === generalData.id) > 1 ? 1 : 0)) + " shoots"}</Typography> */}
                  </ExpansionPanelSummary>
                </Paper>

                <ExpansionPanelDetails
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >

                  {
                    clientCompanyShoots[0].map(shoot =>
                      shoot.shoot_id !== generalData.id &&
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid #e0e0e0",
                          alignItems: "center"
                        }}
                      >

                        <Box
                          component="div"
                          m={1}
                          style={{
                            padding: "10px",
                          }}
                        >
                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              ID:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {shoot.shoot_id}
                            </Typography>
                          </Box>


                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              Name:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {shoot.shoot_name}
                            </Typography>
                          </Box>

                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              Date:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {moment(shoot.shoot_date).format("MMM Do YY")}
                            </Typography>
                          </Box>

                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              Status:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {shoot.status ? shoot.status : "open"}
                            </Typography>
                          </Box>

                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              Inovice ID:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {shoot.invoice_id}
                            </Typography>
                          </Box>

                          <Box
                            style={{ display: "flex" }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.7em",
                                fontWeight: 600,
                                marginRight: "10px",
                                color: "#730903"
                              }}
                            >
                              Inovice Status:
                            </Typography>
                            <Typography
                              style={{
                                fontSize: 10,
                                color: "#9A9A9A",
                                fontWeight: 300,
                              }}
                            >
                              {shoot.full_paid === 1 ? "paid" : "unpaid"}
                            </Typography>
                          </Box>



                        </Box>

                        <Box>
                          <Link to={`/shoots/${shoot.shoot_id}`} target="_blank" style={{ textDecoration: "none" }}>
                            <Button
                              color="gray"
                              variant="contained"
                              size="large"
                              style={{
                                marginBottom: "13px",
                                height: "30px",
                                width: "200px"
                              }}
                            >
                              See Shoot
                            </Button>
                          </Link>

                          <Link to={`/invoice/${shoot.client_unique_string}`} target="_blank" style={{ textDecoration: "none" }}>
                            <Button
                              color="gray"
                              variant="contained"
                              size="large"
                              style={{
                                height: "30px",
                                width: "200px"
                              }}
                            >
                              See Invoice
                            </Button>
                          </Link>
                        </Box>

                      </Box>
                    )
                  }

                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Grid>
          }

        </Fragment>

      }
    />
  )
}

const ShootBilling = props => {
  let id = props.match.params.shoot_id

  return (
    <MuiThemeProvider theme={billingTheme}>
      <BillingContainer shootId={id}>
        <ShootBillingContent {...props} />
      </BillingContainer>
    </MuiThemeProvider>
  )
}

export default withRouter(ShootBilling)
